<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog persistent v-model="dialog" style="/*this is not yet working*/min-width: 580px;" width="unset"
        :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-form ref="myForm" v-on:submit.prevent="createtask" :disabled="saving">
            <v-card :min-width="$vuetify.breakpoint.xs ? '100vw' : '600px'" style="min-height: 300px;">
                <v-card-title dense class="text-center justify-center py-6">
                    <div class="text-h3">Upload DXF</div>
                </v-card-title>

                <v-alert v-if="error" dense type="warning" dismissible>{{ error }}</v-alert>
                <v-progress-linear v-if="saving" color="orange" indeterminate rounded height="6"></v-progress-linear>

                <div v-if="success">
                    <v-card-text class="text-center justify-center py-6">
                        <v-alert dense type="success">{{ language.t('Vector.CreateTask.taskSaved') }}</v-alert>
                    </v-card-text>
                </div>

                <div v-show="!success">
                    <v-card-text class="text-center justify-center py-6">
                        <v-file-input v-model="form.file" ref="fileupload"
                            :placeholder="language.t('Vector.CreateTask.chooseFile')" @change="onSelectFile" accept=".dxf"
                            truncate-length="15" :rules="[fileSupported]"></v-file-input>
                    </v-card-text>

                    <v-card-actions class="card-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="error" x-large v-on:click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-btn color="success" x-large type="submit"
                            :disabled="!complete || saving || (fileSupported !== true)">
                            <v-icon>mdi-check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-form>
    </v-dialog>
</template>
  
<script>
import DXFFile from "../webcomponents/models/DXFFile";
import Motionplan from "../models/Motionplan";
import * as CONST from "../Constants";

export default {
    components: {
    },
    props: {
        /* Map.vue reference */
        map: {
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
            complete: false,
            saving: false,
            error: null,
            success: false,
            task: null,
            fileSupported: true,
            loading: false,
            newDXF: null,

            form: {
                file: null,
                type: "",
            },
        };
    },
    mounted: function () { },
    computed: {},
    watch: {
        form: {
            /* validate if the form data is complete */
            handler(val) {
                if (val.file && val.type != "") this.complete = true;
                else this.complete = false;
            },
            deep: true,
        },
    },
    methods: {
        onSelectFile(file) {
            if (file == null) {
                this.form.type = "";
                this.fileSupported = true;
                return;
            }

            this.error = null;
            switch (file.type) {
                case "application/dxf":
                    this.form.type = "dxf";
                    break;
                case "":
                    // check file extension
                    if (file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0] == ".dxf") {
                        this.form.type = "dxf";
                        break;
                    }
                default:
                    this.error = "Wrong file type";
                    return;
            }
            // set taskname to filename if name is still empty
            if (this.form.name == "") {
                this.form.name = file.name.replace(/\.[^/.]+$/, "");
                this.form.name = this.form.name.substring(0, 45);
            }

            this.layers = [];
            if (this.form.type === "dxf") {
                console.log("check file version");
                const reader = new FileReader();
                reader.onload = (res) => {
                    var dxf = new DXFFile(res.target.result);
                    this.newDXF = dxf;
                    this.checkAcadVerSupport(dxf.acadVer);
                };
                reader.onerror = (err) => console.log(err);
                reader.readAsText(file);
            }
        },
        checkAcadVerSupport(versionString) {
            if (CONST.__SUPPORTED_ACADVERS.indexOf(versionString) !== -1) {
                this.fileSupported = true;
            } else {
                this.fileSupported = this.language.t("Vector.CreateTask.unsupportedVersion");
            }
        },
        createtask() {
            this.saving = true;
            this.error = null;
            let data = new FormData();

            data.set("route_file", this.form.file);
            console.log(this.$selectedTask.taskId);
            this.$axios
                .post(route("api.tasks.replaceDXF", this.$selectedTask.taskId), data, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    this.$axios
                        .get(route("api.tasks.dxf.download", res.data.oldMotionPlan))
                        .then((motionplan) => {
                            var parsedMotionplan = new Motionplan(motionplan.data);
                            this.$axios
                                .get(route("api.tasks.dxf.download", res.data.newDXF))
                                .then((dxf) => {
                                    var dxfFile = new DXFFile(dxf.data);
                                    this.createMotionPlanFromDXF(dxfFile, parsedMotionplan);

                                    this.$emit("taskCreated");
                                    this.success = true;
                                    this.saving = false;
                                })
                                .catch((error) => {
                                    console.log(error)
                                    this.error = error.response.data.error;
                                    this.saving = false;
                                });
                        })
                        .catch((error) => {
                            this.error = error.response.data.error;
                            this.saving = false;
                        });
                }).catch((error) => {
                    this.error = error.response.data.error;
                    this.saving = false;
                });

        },
        createMotionPlanFromDXF(dxfFile, parsedMotionplan) {
            if (!this.$auth.isAdmin) return;
            console.log(dxfFile)
            let data = new FormData();
            data.set('line', JSON.stringify(dxfFile.groups[0][0])); // looking for layer 0 and the first feature maybe? doesnt seem like the best option
            if (this.$auth.subscription == "__SUB_CIVIL_VECTOR") {
                data.set('type', "VCT");
            } else {
                data.set('type', "RBP");
            }

            this.$axios.post(route('api.motionplan.post'), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((res) => {
                    console.log(res);
                    var newMotionplan = new Motionplan(res.data);
                    this.compareMotionPlans(parsedMotionplan, newMotionplan);
                })
        },
        compareMotionPlans(original, newfile) {
            newfile.data.forEach(segment => {
                //empty parameters
                if (segment.segment[0] != "1") {
                    if (this.$auth.subscription == "__SUB_CIVIL_VECTOR") {
                        segment.segment[10] = "0";
                        segment.segment[11] = "2";
                        segment.segment[12] = "151";
                        segment.segment[13] = "0";
                        segment.segment[14] = "156";
                    } else {
                        segment.segment[10] = "0";
                        segment.segment[11] = "1";
                        segment.segment[12] = "51";
                        segment.segment[13] = "1";
                        segment.segment[14] = "0";
                    }
                } else {
                    segment.segment[10] = "1";
                    segment.segment[11] = "0";
                    segment.segment[12] = "0";
                    segment.segment[13] = "0";
                    segment.segment[14] = "0";
                }

                for (let index = 15; index < segment.segment.length; index++) {
                    segment.segment[index] = 0;

                }

                original.data.forEach(originalSegment => {
                    if ((segment.segment[1] == originalSegment.segment[1]) && (segment.segment[2] == originalSegment.segment[2]) && (segment.segment[4] == originalSegment.segment[4]) && (segment.segment[5] == originalSegment.segment[5]) && (segment.segment[6] == originalSegment.segment[6]) && (segment.segment[8] == originalSegment.segment[8])) {
                        for (let index = 10; index < segment.segment.length; index++) {
                            segment.segment[index] = originalSegment.segment[index];
                        }
                        return;
                    }
                });
            });

            this.map.mapTaskInfo.getChildElement("MOTIONPLAN").drawLayer(newfile, this.map.task.projection);
            //motionplan opslaan en reloaden
            let data = new FormData();
            data.set("file", new File([new Blob([this.map.mapTaskInfo.getChildElement("MOTIONPLAN").motionplan.getMotionplanString()])], "motionplan.log"));

            this.$axios.post(route("api.tasks.addmotionplan", this.map.task.taskId), data, { headers: { "Content-Type": "multipart/form-data" }, }).then((res) => {
                this.clearForm();
                this.dialog = false;
                this.$emit("closeTask");
                this.$emit("openTask", res.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        clearForm() {
            this.$refs.fileupload.reset();
            this.form.file = null;
            this.form.projection = "";
            this.form.name = "";
            this.form.description = "";
            this.form.type = "";
            this.error = null;
            this.success = false;
        },
    }
}
</script>
  
<style scoped></style>
  